<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="report-page">
    <div class="report-image" v-html="htmlData[index]"></div>
    <div class="report-view-full">
      <router-link target="_blank"  to='/contact'>
        <div class="button">查看完整报告</div>
      </router-link> 
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      index: null,
      htmlData: [
        `
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_0.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_1.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_2.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_3.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_4.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_5.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_6.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631124402127273984_1631124449204142080_1631124452702134272_7.jpg">
          `,
          `
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_0.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_1.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_2.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_3.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_4.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_5.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_6.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1630039691833204736_1630039750826094592_1630039752034197504_7.jpg">

          `,
          `
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_0.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_1.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_2.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_3.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_4.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_5.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_6.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1602622422480154624_1602622630488272896_1602622634447839232_7.jpg">
          `,
          `
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_0.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_1.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_2.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_3.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_4.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_5.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_6.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1569892282046439424_1569892282050633728_1569892285003649024_7.jpg">

          `,
          `
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_0.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_1.jpg?">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_2.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_3.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_4.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_5.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_6.jpg">
            <img src="https://wlmvp-cos.weiling.cn/1426085173111427072/split/1631225060088119296_1631225181559357440_1631225185518723072_7.jpg">
          `,
          `
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_0.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_1.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_2.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_3.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_4.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_5.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_6.jpg">
            <img src="https://wlmvp-cos.weiling.cn/split/1542356352540741632_1542356449655656448_1542358020779167744_7.jpg">
          `,
      ],
    };
  },
  mounted() {
    this.index = this.$route.query.index
  },
  methods: {},
};
</script>
<style lang="scss">

.report-page {
  padding-top: 60px;
  position: relative;
}

.report-image {
  img {
    display: block;
    margin: 0;
  }
}

.report-view-full {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 737px;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 75%, #FFFFFF 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 72px;
  box-sizing: border-box;
    

  .button {
    margin-top: 48px;
    width: 126px;
    height: 44px;
    background: #5a2df5;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    cursor: pointer;
  }
}


</style>
